import axios from 'axios';
export default {
	install(Vue: any, options: any = {}) {
		function get(path: string, query: object = {}): any {
			return axios
				.get(path, {
					baseURL: options.domain,
					params: query
				})
				.then(res => {
					if (res.status == 200) {
						let data = res.data;
						if (options.handles && options.handles.success) {
							data = options.handles.success.call(undefined, data, {
								path,
								query
							});
						}
						return data;
					} else {
						throw new Error(res.statusText);
					}
				});
		}
		function post(path: string, data: object = {}): any {
			console.log(path);
			return Promise.resolve();
		}

		Vue.prototype.$api = {
			get: get,
			post: post,
			page: {
				getDetail(id: number) {
					return get('/api/svc/cms/page/articles/' + id + '?_include=items');
				}
			}
		};
	}
};
